import {currentUserModule} from "@/store";

const ROLE_Monitor = "Monitor";
const ROLE_Physician = "Physician";
const ROLE_SuperAdmin = "SuperAdmin";
const ROLE_Admin = "Admin";


const rolesVisitYearDurationDescriptiveStatisticsView=
    [ROLE_Monitor, ROLE_Physician, ROLE_SuperAdmin, ROLE_Admin];

const rolesPatientChartView=
    [ROLE_Monitor, ROLE_Physician, ROLE_SuperAdmin, ROLE_Admin];

const rolesPatientGenderPercentagetView=
    [ROLE_Monitor, ROLE_Physician, ROLE_SuperAdmin, ROLE_Admin];

const rolesNewPatientCenterView=
    [ROLE_Monitor, ROLE_SuperAdmin, ROLE_Admin];

const rolesCenterInfoView=
    [ROLE_Monitor, ROLE_SuperAdmin, ROLE_Admin];

const rolesAgeAtFirstDiagnosisChartView=
    [ROLE_Monitor, ROLE_Physician, ROLE_SuperAdmin, ROLE_Admin];

const rolesCurrentAgeCountView=
    [ROLE_Monitor, ROLE_Physician, ROLE_SuperAdmin, ROLE_Admin];

const rolesTimeSinceLastVisitView=
    [ROLE_Monitor, ROLE_Physician, ROLE_SuperAdmin, ROLE_Admin];

const rolesRatingView=
    [ROLE_Monitor, ROLE_Physician, ROLE_SuperAdmin, ROLE_Admin];

const rolesComorbiditiesView=
    [ROLE_Physician, ROLE_SuperAdmin, ROLE_Admin];


export function canSeeVisitYearDurationDescriptiveStatisticsView() {
    return rolesVisitYearDurationDescriptiveStatisticsView.includes(currentUserModule.roleIdentifier);
}

export function canSeePatientChartView() {
    return rolesPatientChartView.includes(currentUserModule.roleIdentifier);
}

export function canSeePatientGenderPercentagetView() {
    return rolesPatientGenderPercentagetView.includes(currentUserModule.roleIdentifier);
}

export function canSeeNewPatientCenterView() {
    return rolesNewPatientCenterView.includes(currentUserModule.roleIdentifier);
}

export function canSeeCenterInfoView() {
    return rolesCenterInfoView.includes(currentUserModule.roleIdentifier);
}

export function canSeeAgeAtFirstDiagnosisChartView() {
    return rolesAgeAtFirstDiagnosisChartView.includes(currentUserModule.roleIdentifier);
}

export function canSeeCurrentAgeCountView() {
    return rolesCurrentAgeCountView.includes(currentUserModule.roleIdentifier);
}

export function canSeeTimeSinceLastVisitView() {
    return rolesTimeSinceLastVisitView.includes(currentUserModule.roleIdentifier);
}

export function canSeeRatingView() {
    return rolesRatingView.includes(currentUserModule.roleIdentifier);
}

export function canSeeComorbiditiesView() {
    return rolesComorbiditiesView.includes(currentUserModule.roleIdentifier);
}